import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";

const Student = React.createContext();

export const useStudentSubmission = () => {
  return useContext(Student);
};

// const startDate = new Date(moment().startOf("isoweek"));
const startDate = new Date(moment().subtract(30, "days"));
// const endDate = new Date(moment().subtract(30, "days"));
// const endDate = new Date(moment().endOf("isoweek"));
const endDate = new Date(moment(new Date()).format("MM/DD/YYYY"));

const StudentSubmissionContext = ({ children }) => {
  const { location } = useHistory();
  const [
    studentAttachmentsForGradingSummary,
    setStudentAttachmentsForGradingSummary,
  ] = useState([]);
  const [studentAttachmentsForAssignment, setStudentAttachmentsForAssignment] =
    useState([
      {
        id: 1,
        type: "text",
        info: "",
      },
      {
        id: 2,
        type: "voice",
        info: "",
      },
      {
        id: 3,
        type: "video",
        info: "",
      },
      {
        id: 4,
        type: "link",
        info: [],
      },
      {
        id: 5,
        type: "file",
        info: [],
      },
    ]);
  const [currentAssignmentCode, setCurrentAssignmentCode] = useState(null);
  const [currentAssignmentData, setCurrentAssignmentData] = useState(null);
  const [currentSubjectData, setCurrentSubjectData] = useState({});
  const [currentPage, setCurrentPage] = useState("");
  const [subjectListForDropdown, setSubjectListForDropdown] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [globalSearch, setGlobalSearch] = useState(null);
  const [dateFilter, setDateFilter] = useState({
    start: startDate,
    end: endDate,
  });
  const [isFilteredByCreationDate, setIsFilteredByCreationDate] =
    useState(false);

  const defaultDateHandler = () => {
    setDateFilter({
      start: null,
      end: null,
    });
  };

  const getMaxScore = (rubrics, field) => {
    return rubrics.reduce((acc, curr) => {
      if (curr[field] > acc) {
        acc = curr[field];
      }
      return acc;
    }, 0);
  };

  const getOverallScore = (rubrics) => {
    return rubrics.reduce(
      (acc, curr) => {
        acc.score += curr.score;
        acc.max += curr.max;
        return acc;
      },
      { score: 0, max: 0 }
    );
  };

  const findRubricItem = (criteria, criteriaId) => {
    return criteria.find((item) => item.criteriaId === criteriaId);
  };

  const getColorBasedOnPoints = (confidence) => {
    if (confidence >= 90) return "#52c41a";
    if (confidence >= 80) return "#faad14";
    if (confidence >= 70) return "#f5222d";
    return "#f5222d";
  };

  const formatRubricScores = (assignmentRubrics, selectedRubric) => {
    return selectedRubric.map((rubric) => {
      const selectedRubricItem = assignmentRubrics.find(
        (item) => item.rubricItemId === rubric.rubricItemId
      );
      const points = findRubricItem(
        selectedRubricItem.rubricCriteria,
        rubric.criteriaId
      ).points;
      const max = getMaxScore(selectedRubricItem.rubricCriteria, "points");
      return {
        id: rubric.rubricItemId,
        criteriaId: rubric.criteriaId,
        label: selectedRubricItem.rubricItemTitle,
        score: points,
        options: selectedRubricItem.rubricCriteria,
        max: max,
        comment: rubric.justification,
        confidence: rubric.confidence,
        color: getColorBasedOnPoints((points / max) * 100),
      };
    });
  };

  function getGrade(percentage) {
    if (percentage < 0 || percentage > 100) {
      return "Invalid percentage";
    }

    if (percentage > 90) {
      return "A+";
    } else if (percentage > 85) {
      return "A";
    } else if (percentage > 80) {
      return "A-";
    } else if (percentage > 70) {
      return "B+";
    } else if (percentage > 60) {
      return "B";
    } else {
      return "F";
    }
  }

  return (
    <Student.Provider
      value={{
        studentAttachmentsForAssignment,
        setStudentAttachmentsForAssignment,
        setCurrentAssignmentCode,
        currentAssignmentData,
        setCurrentAssignmentData,
        currentSubjectData,
        setCurrentSubjectData,
        currentPage,
        setCurrentPage,
        subjectListForDropdown,
        setSubjectListForDropdown,
        teacherList,
        setTeacherList,
        selectedSubject,
        setSelectedSubject,
        selectedTeacher,
        setSelectedTeacher,
        globalSearch,
        setGlobalSearch,
        dateFilter,
        setDateFilter,
        defaultDateHandler,
        isFilteredByCreationDate,
        setIsFilteredByCreationDate,
        formatRubricScores,
        getGrade,
        getOverallScore,
        studentAttachmentsForGradingSummary,
        setStudentAttachmentsForGradingSummary,
      }}
    >
      {children}
    </Student.Provider>
  );
};

export default StudentSubmissionContext;
